import { MutationKeyConfig, QueryKeyConfig } from '../api-helper';

export const departmentsApiKeyStore = {
    getDepartments: (): QueryKeyConfig => ({
        queryKey: [`GET_DEPARTMENTS`],
        route: `/Department`,
    }),
    getDepartmentsWithManager: (): QueryKeyConfig => ({
        queryKey: [`GET_DEPARTMENTS_WITH_MANAGER`],
        route: `/Department/AllDepartmentsWithManager`,
    }),
    getDepartmentById: (departmentID: number): QueryKeyConfig => ({
        queryKey: [`GET_DEPARTMENT_BY_ID`, departmentID],
        route: `/Department/${departmentID}`,
        isEnabled: !!departmentID && departmentID >= 0,
      }),
    createDepartment: (): MutationKeyConfig => ({
        mutationKey: [`CREATE_DEPARTMENT`],
        route: `/Department`,
        action: 'POST',
      }),
    updateDepartment: (): MutationKeyConfig => ({
        mutationKey: [`UPDATE_DEPARTMENT`],
        route: `/Department`,
        action: 'PUT',
    }),
    deleteDepartment: (departmentID: number): MutationKeyConfig => ({
        mutationKey: [`DELETE_DEPARTMENT`, departmentID],
        route: `/Department/${departmentID}`,
        action: 'DELETE',
    }),
    getQBODepartments: (): QueryKeyConfig => ({
    queryKey: [`GET_Department_QBDEPARTMENTS`],
    route: `/Department/QBODepartments`,
  }),
};
